<!-- 版本升级 -->
<template>
  <!-- 工具版 -->
  <div>
    <ElTooltip :effect="isBusiness ? 'dark' : 'light'" placement="bottom" popper-class="business-pop">
      <div slot="content" class="content" :style="{color: isBusiness ? '#E6C3A6' : '#006AFF'}">
        <div v-if="!officialLastThreeDaysExceeding">
          {{ tooltipText }}
        </div>
        <div v-else-if="officialLastDays > 1">
          {{ isBusiness ? '商机版' : '工具版' }}还有 <VersionHintTime :data="officialLastDays"/> 天到期
        </div>
        <div v-else-if="officialLastDays === 1 && officialLastThreeDaysExceeding && DD">
          {{ isBusiness ? '商机版' : '工具版' }}还有 <VersionHintTime :data="HH"/> : <VersionHintTime :data="MM"/> : <VersionHintTime :data="DD"/>  到期
        </div>
      </div>
      <div
        v-if="!isBusiness"
        class="free"
        @mouseover="handleFreeMouseover"
        @mouseleave="handleFreeMouseleave">
        <img
          src="@/assets/images/free-icon.png"
          class="free-icon"
        />
        工具版
      </div>
      <div
        v-else-if="isBusiness"
        class="official"
        @mouseover="handleFreeMouseover"
        @mouseleave="handleFreeMouseleave">
        <img
          src="https://staticres.linhuiba.com/project-custom/pms/icon/official_icon.png"
          class="official-icon"
        />
        商机版
      </div>
    </ElTooltip>
  </div>
  <!-- 商机版 -->

  <!-- 正式版 且时间大于1天 小于等于3 -->
  <!-- <div v-else-if="officialLastDays > 1" class="official">
    <img src="https://staticres.linhuiba.com/project-custom/pms/icon/official_icon.png" class="official-icon"/>
    正式版还有 <VersionHintTime :data="officialLastDays"/> 天到期
  </div> -->
  <!-- 正式版 等于1天 -->
  <!-- <div v-else-if="officialLastDays === 1 && officialLastThreeDaysExceeding && DD" class="official">
    <img src="https://staticres.linhuiba.com/project-custom/pms/icon/official_icon.png" class="official-icon"/>
    正式版还有 <VersionHintTime :data="HH"/> : <VersionHintTime :data="MM"/> : <VersionHintTime :data="DD"/>  到期
  </div> -->
</template>

<script>
import dayjs from 'dayjs';
import { dateFns } from '@lhb/func';
import VersionHintTime from '@/layout/components/Header/VersionHintTime.vue';
import eventLib from '@/common/utils/document-event';

export default {
  components: {
    VersionHintTime,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      text: '',
      timer: null, // 获取数据的定时器
      HH: '',
      MM: '',
      DD: '',
    };
  },
  computed: {
    /**
     * 剩余天数
     */
    officialLastDays() {
      if (!this.data || !this.data.versionEnd) return null;
      /**
       * 计算两个时间差值，向上取整，包括当天
       */
      return Math.ceil(dayjs(this.data.versionEnd).diff(dayjs(), 'day', true)) + 1; // 加上当天 1
    },
    /**
     * 判断正式版最后三天
     */
    officialLastThreeDaysExceeding() {
      return this.officialLastDays <= 3;
    },
    tooltipText() {
      return `有效期至${this.data.versionEnd}`;
    },
    // 是否是商机版
    isBusiness() {
      return this.data.versionType === 'REQUIREMENT';
    }
  },
  watch: {
    data: {
      handler(user) {
        this.text = user.versionTypeName;
        console.log(this.data, 'data');
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.setIntervalOfficialLastDays();

    eventLib.on('LOADING', () => {
      this.setIntervalOfficialLastDays();
      this.text = this.data.versionTypeName;
    });
  },

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    /**
     * 设置正式版倒计时
     */
    setIntervalOfficialLastDays() {
      this.clearTimer();
      /**
       * 如果两个时间等于1天，说明要倒计时了
       */
      if (this.officialLastDays === 1) {
        this.timer = setInterval(() => {
          const timestamp = dayjs(this.data.versionEnd).add(1, 'day').diff(dayjs());
          const hh = dateFns.doubleDigit(Math.floor(timestamp / 1000 / 60 / 60));
          const mm = dateFns.doubleDigit(Math.floor((timestamp - hh * 1000 * 60 * 60) / 1000 / 60));
          const dd = dateFns.doubleDigit(Math.floor((timestamp - hh * 1000 * 60 * 60 - mm * 1000 * 60) / 1000));
          this.HH = hh;
          this.MM = mm;
          this.DD = dd;
        }, 1000);
      } else {
        this.HH = '';
        this.MM = '';
        this.DD = '';
      }
    },

    // 清除计时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    /**
     * 免费版鼠标移入
     */
    handleFreeMouseover() {
      let text = '';
      if (this.data.versionType === 'TOOL') {
        text = `${this.data.versionTypeName} | 您的特权已过期 ${dayjs().add(1, 'day').diff(dayjs(this.data.versionStart), 'day')} 天`;
      } else {
        text = `${this.data.versionTypeName} | 有效期至 ${dayjs(this.data.versionEnd).format('YYYY.MM.DD')}`;
      }
      this.text = text;
    },
    /**
     * 免费版鼠标移出
     */
    handleFreeMouseleave() {
      this.text = this.data.versionTypeName;
    }
  },

};
</script>

<style lang="less" scoped>
.business-pop {
  /deep/ .el-tooltip__popper.is-light {
    border: none !important;
  }
  .content {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #E6C3A6;
    line-height: 16px;
  }
}
.free {
  padding: 6px 8px 6px 6px ;
  height: 28px;
  background: #FFFFFF;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #006AFF;
  text-align: center;
  margin-right: 12px;
  border: 1px solid #E2EAFF;
  cursor: pointer;
  .f-DAJ(row, center);
  &-icon {
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }
}

.official {
  padding: 6px 8px 6px 6px;
  height: 28px;
  background: #4E505C;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #E6C3A6;
  text-align: center;
  margin-right: 12px;
  cursor: pointer;
  .f-DAJ(row, center);
  &-icon {
    width: 17px;
    height: 16px;
    margin-right: 1px;
  }
}
</style>

<style lang="less">
.el-tooltip__popper.is-light {
  border: none;
  box-shadow: 0px 5px 5px 5px rgba(0,0,0,0.08)
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #FFFFFF !important;
}
</style>

